import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Спасибо за регистрацию на портале для перевозчиков GT2!", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Осталось заявок с повышенной ставкой", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ui_modal_with_content = _resolveComponent("ui-modal-with-content")!

  return (_openBlock(), _createBlock(_component_ui_modal_with_content, {
    target: "modal",
    "overlay-color": "dark-blue",
    "has-custom-container-style": "",
    width: 600,
    class: _normalizeClass(_ctx.$style.container),
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.container)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.imgWrapper)
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.content)
        }, [
          _createElementVNode("h1", {
            class: _normalizeClass(_ctx.$style.title)
          }, " +5% к ставке на первые три заявки! ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.text)
          }, [
            _hoisted_1,
            _createTextVNode(" В качестве приветственного бонуса мы повышаем ставку на 5% по первым трем заявкам, которые вы возьмете на портале. ")
          ], 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.$style.counterRow)
          }, [
            _hoisted_2,
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style.counter)
            }, _toDisplayString(3 - _ctx.ordersCounter), 3)
          ], 2),
          (!_ctx.counterparty)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.$style.additionalText)
                }, " Бронь заявок и назначение ресурсов доступно после внесения информации об организации ", 2),
                _createVNode(_component_router_link, {
                  to: _ctx.getOrgRoute(),
                  class: _normalizeClass(_ctx.$style.link)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ui_button, {
                      class: _normalizeClass(_ctx.$style.button)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перейти к созданию Организации ")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["to", "class"])
              ], 64))
            : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}